<template>
  <div>
    <el-form
      label-position="top"
      :model="file"
      :rules="rules"
      ref="fileForm"
    >
      <el-form-item
        label="Leírás"
        prop="description"
      >
        <el-input
          v-model="file.description"
          type="textarea"
        />
      </el-form-item>
      <el-upload
        v-if="formType === 'add'"
        class="upload-demo"
        drag
        action=""
        :auto-upload="false"
        :on-change="handleFileChange"
        :file-list="fileList"
        :limit="1"
        :on-exceed="handleError"
        :on-remove="handleRemove"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Húzd ide a fájlt vagy <em>kattints a feltöltéshez</em></div>
      </el-upload>
    </el-form>
  </div>
</template>

<script>
  export default {
    props: ['defaultFile', 'formType'],
    data() {
      return {
        file: {
          file: {}
        },
        source: null,
        fileList: [],
        uploadKey: 0,
        rules: {},
      };
    },

    watch: {
      defaultFile: {
        handler(newVal) {
          if(this.formType === 'update') {
            this.file = JSON.parse(JSON.stringify(newVal));
          } else {
            this.file =  {
              file: {}
            }
          }
        },
        deep: true,
      },
    },
    async mounted() {
      if (this.formType === 'add') {
        this.file = {
          file: {},
        };
      } else {
        this.file = JSON.parse(JSON.stringify(this.defaultFile));
      }
    },
    methods: {
      async handleFileChange(file) {
        if (this.isFileCorrect(file)) {
            this.file.file.path = URL.createObjectURL(file.raw);
            this.source = file.raw;
            this.file.file_size = file.raw.size;
            this.file.file_extension = file.name.split('.').pop();
            this.uploadKey++;
        } else {
          this.fileList = [];
          this.uploadKey++;
        }
      },
      handleError(files) {
        this.$messageWrapper.warning('Egyszerre egy fájl adható hozzá');
      },
      handleRemove(file) {
        this.fileList = [];
        this.file = {
          file: {},
        };
      },
      isFileCorrect(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isLt2M) {
          this.$messageWrapper.error('Fajl mérete nem lehet nagyobb, mint 10MB!');
          return isLt2M;
        }
        return isLt2M;
      },
    }
  };
</script>
